import * as React from "react";
import { withRouter } from "react-router-dom";

import { MenuItemLink, Responsive, setSidebarVisibility } from "react-admin";
import { Collapse, MenuItem, Typography } from "@material-ui/core";
import { useState } from "react";

import { Resources } from "../providers/wgProviderHelper";
import { useDispatch } from "react-redux";

// const Logo = ({ src }) => {
//   const classes = useStyles();
//   return <Avatar className={classes.avatar} src={src}></Avatar>;
// };
const menuItemsfromResource = Resources.reduce(
  (result, item) => {
    if (!item.menu) return result;
    const menuItem = {
      name: item.path,
      text: item.menu.text,
      icon: item.menu.icon,
    };
    if (item.menu.parentMenu) {
      //Create Parent menu if not exists
      if (
        result.filter((ele) => ele.name === item.menu.parentMenu).length === 0
      ) {
        result.push({
          name: item.menu.parentMenu,
          text: item.menu.parentMenu,
          subMenu: [menuItem],
        });
        return result;
      } else {
        result = result.map((ele) => {
          if (ele.name === item.menu.parentMenu) {
            ele.subMenu.push(menuItem);
          }
          return ele;
        });
        return result;
      }
    } else {
      result.push(menuItem);
      return result;
    }
  },
  [
    { name: "", text: "Menu" /*icon: <LabelIcon /> */ },
    {
      name: "payment",
      text: "Payment",
      // icon: <Logo src={paymentLogo} />,
    },
    {
      name: "ci",
      text: "Customer Insight",
      // icon: <Logo src={ciLogo} />,
    },
    {
      name: "bi",
      text: "Business Insight",
      // icon: <Logo src={biLogo} />,
    },
    {
      name: "management",
      text: "Management" /* icon: <FiberManualRecordIcon />*/,
    },
  ]
);

const Menu = ({ onMenuClick, logout }) => {
  const dispatch = useDispatch();
  const [collapse, setCollapse] = useState(
    menuItemsfromResource
      .filter((item) => {
        return item.subMenu;
      })
      .map((item) => {
        return { name: item.name, open: false };
      })
  );

  const handleClick = (itemName) => {
    setCollapse(
      collapse.map((item) => {
        if (item.name === itemName) {
          item.open = !item.open;
        }
        return item;
      })
    );
  };

  const onSubMenuClick = (variable) => {
    dispatch(setSidebarVisibility(false));
    onMenuClick(variable);
  };

  return (
    <div>
      {menuItemsfromResource.map((item) => {
        let result;
        if (item.subMenu) {
          const subMenuComponent = (
            <MenuItem
              key={item.name}
              primaryText={item.text}
              leftIcon={item.icon}
              onClick={() => handleClick(item.name)}
            >
              {/* {item.icon} */}
              <Typography style={{ paddingLeft: 15 }}>{item.text}</Typography>
            </MenuItem>
          );

          result = (
            <>
              {subMenuComponent}
              <Collapse
                in={collapse.some(
                  (itemSet) => itemSet.name === item.name && itemSet.open
                )}
                timeout="auto"
                unmountOnExit
              >
                <div style={{ maxHeight: 300, overflowY: "scroll" }}>
                  {item.subMenu.map((sub) => {
                    return (
                      <MenuItemLink
                        key={sub.name}
                        to={`/${sub.name}`}
                        primaryText={sub.text}
                        leftIcon={sub.icon}
                        onClick={onSubMenuClick}
                        style={{ paddingLeft: 30, fontSize: 14 }}
                      />
                    );
                  })}
                </div>
              </Collapse>
            </>
          );
        } else {
          result = (
            <MenuItemLink
              key={item.name}
              to={`/${item.name}`}
              primaryText={item.text}
              leftIcon={item.icon}
              onClick={onSubMenuClick}
              style={{ color: "orange" }}
            />
          );
        }

        return result;
      })}
      <Responsive small={logout} medium={null} />
    </div>
  );
};

export default withRouter(Menu);
